Object.defineProperty(exports, "__esModule", { value: true });
exports.registerEnum = exports.enumsRegistry = void 0;
const graphql_1 = require("graphql");
const error_1 = require("./error");
const registry_1 = require("./registry");
var registry_2 = require("./registry");
Object.defineProperty(exports, "enumsRegistry", { enumerable: true, get: function () { return registry_2.enumsRegistry; } });
const convertNativeEnumToGraphQLEnumValues_1 = require("./convertNativeEnumToGraphQLEnumValues");
function registerEnum(enumDef, options) {
    if (typeof options === 'string') {
        options = { name: options };
    }
    const { name, description, fieldsConfig } = options;
    if (registry_1.enumsRegistry.has(enumDef)) {
        throw new error_1.EnumError(name, `Enum is already registered`);
    }
    const values = convertNativeEnumToGraphQLEnumValues_1.convertNativeEnumToGraphQLEnumValues(enumDef, fieldsConfig, options.useKeys);
    const enumType = new graphql_1.GraphQLEnumType({
        name,
        description,
        values
    });
    registry_1.enumsRegistry.set(enumDef, enumType);
    return enumType;
}
exports.registerEnum = registerEnum;
//# sourceMappingURL=registerEnum.js.map